// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jgDG","index":"styles_index__3UlTf"};